$(document).ready(function () {
    setTimeout(function () {
        $('body .active-thumb').trigger('click');
        //alert($( ".floating-frame option:selected" ).text());

        //console.log("cscasc");
        //  $('.floating-frame select').val('canvas+black frame').addClass('change');

        //$('.floating-frame select').val('canvas+black frame').trigger('change');
    }, 1000);
    $('.floating-frame select').addClass("ddd");
    $('body #add-black-frame').click(function () {

        if ($(this).is(':checked')) {
            //alert("dd dd");
            $('.floating-frame select').val('canvas+black frame').trigger('change');
        } else {
            // alert("dd");
            $('.floating-frame select').val('canvas').trigger('change');

        }
    });
})
document.querySelectorAll('.option-button').forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();

      // Get the value and select ID from the button's data attributes
      const value = this.getAttribute('data-value');
      const selectId = this.getAttribute('data-select-id');

      // Find the corresponding select element
      const selectElement = document.getElementById(selectId);

      // Set the select value to the button's value
      selectElement.value = value;

      // Remove active class from all related buttons
      document.querySelectorAll(`[data-select-id="${selectId}"]`).forEach(function(btn) {
        btn.classList.remove('active');
      });

      // Add active class to the clicked button
      this.classList.add('active');

      // Trigger a change event to notify any other scripts that may be listening
      const changeEvent = new Event('change', { 'bubbles': true, 'cancelable': true });
      selectElement.dispatchEvent(changeEvent);
    });
});
